<app-header></app-header>
<app-announcement></app-announcement>
<p-confirmDialog></p-confirmDialog>
<style>
  /* Equal size tab styling */
  .nav_main {
    display: flex;
    margin: 0;
    padding: 0;
  }
  .nav_main > li {
    flex: 1 1 0;
    text-align: center;
    min-width: 180px; /* increased minimum width */
  }
  .nav_main > li > a,
  .nav_main > li.active > a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;              /* Fixed uniform height */
    padding: 0 32px;            /* increased horizontal padding */
    box-sizing: border-box;
    font-weight: 400;           /* reverted */
    font-size: 14px;            /* reverted */
    border-radius: 0;           /* Prevent radius changing dimensions */
    transition: background-color .15s ease, color .15s ease;
    text-decoration: none;     /* remove underline */
    border: none !important;   /* remove any bottom border/line */
    box-shadow: none !important;
  }
  /* Keep dimensions identical on state changes */
  .nav_main > li > a:hover,
  .nav_main > li > a:focus,
  .nav_main > li.active > a:hover,
  .nav_main > li.active > a:focus {
    height: 48px;
    padding: 0 32px;
    font-weight: 400;           /* keep consistent */
    font-size: 14px;            /* keep consistent */
    text-decoration: none;
    border: none !important;
    box-shadow: none !important;
  }
  /* Optional: remove outline jump */
  .nav_main > li > a:focus {
    outline: none;
  }

  .external_add_internaluserbtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 15px;          /* consistent with other buttons */
    line-height: 1.42857143;    /* Bootstrap default */
    gap: 4px;
    vertical-align: middle;
  }
  .external_add_internaluserbtn .glyphicon {
    top: 0;
    margin-left: 4px;
  }

  /* Updated: unify styling for internal, master data (same class), external, and bulk upload */
  .add_internaluserbtn,
  .external_add_internaluserbtn,
  .bulk_upload {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 15px;
    line-height: 1.42857143;
    gap: 4px;
    vertical-align: middle;
  }
  .add_internaluserbtn .glyphicon,
  .bulk_upload .glyphicon {
    top: 0;
    margin-left: 4px;
  }
</style>
<div class="fluid-container blw_headermain">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 internal_main" id="exTab1">
      <ul class="nav nav-pills nav_main">
        <li id="id1" [ngClass]="{'active': ShowInternalUser}">
          <a href="#1a" data-toggle="tab" [ngClass]="(hideinternal==true)?'internal-hide':'internal-unhide'"
            (click)="showInternalUser(dtExternal, ExternalUserTableSearch);myExternalUserForm.reset(); $event.preventDefault();">Internal</a>
        </li>
        <li id="id2" [ngClass]="{'active': ShowExternalUser}">
              <a href="#2a" data-toggle="tab" (click)="showExternalUser(dtInternal,InternalUserTableSearch);myForm.reset(); $event.preventDefault();">External</a>
        </li>
   
      </ul>

      
      <!-- Internal Tabls starts here -->
      <div class="tab-content clearfix">
        <div class="tab-pane" [ngClass]="{ 'active': ShowInternalUser}" id="1a">
          <div class="userbtn_main">
            <button type="button" (click)="GetUSerLog()" class="btn userlog_btn">User Log
              <img src="/assets/images/userlog_icon.png">
            </button>
            <button type="button" class="btn transaction_btn" (click)="GetTransaction()">Transactions
              <img src="/assets/images/transaction_icon.png">
            </button>
            <button type="button" (click)="showAddInternalUserArea()" class="btn add_internaluserbtn">Add Internal User
              <span class="glyphicon glyphicon-plus"></span>
            </button>
            <!-- Arvindrvind Add Agency -->
            <button type="button" (click)="GetAgency()" class="btn add_internaluserbtn"> Master Data
              <span class="glyphicon glyphicon-plus"></span>
            </button>
 
            <!--ArvindEnd Arvind Add Agency -->
          </div>
 
          <!-- Internal User Golbal Search Starts-->
          
          <div [hidden]="!ShowInternalUser" class="searchmain">
            <input id="InternalUserTableSearch" #InternalUserTableSearch type="text" class="searchbox" pInputText
              size="50" placeholder="Search Alphanumeric values here..." [(ngModel)]="internalUserGlobalFilter"
              (input)="dtInternal.filterGlobal(internalUserGlobalFilter, 'contains')" />
            <i class="fa fa-search search_modified"></i>
          </div>
          <!-- Internal User Golbal Search Ends-->
          <!-- Add New Internal User starts-->
          <div [hidden]="!showAddInternalUserRow">
            <div class="no-more-tables">
              <form #myForm="ngForm" (ngSubmit)="onAddNewInternalUserSubmit(myForm)">
                <div id="adminComponentTable1" class="addDataInTable">
                  <table>
                    <tr>
                      <td>
                        <div class="addMandatory widthChild85">
                          <input name="sso" type="text" pInputText pKeyFilter="pint" [(ngModel)]="newInternalUser.SSO"
                            minlength="9" maxlength="9" placeholder="SSO" required #sso="ngModel"
                            [pattern]="ssoPattern" />
                        </div>
                        <div style="margin-left: 13px">
                          <span class="input-ErrorField" *ngIf="!duplicateSSO"
                            [ngClass]="(duplicateSSO==true)?'container-hide':'container-unhide'">Duplicate SSO</span>
                          <span class="input-ErrorField"
                            [ngClass]="(validateSSO==true)?'container-hide':'container-unhide'">Invalid SSO</span>
                        </div>
                      </td>
                      <td>
                        <div class="addMandatory widthChild150 marginLeftMin15">
                          <input name="firstName" type="text" pInputText [pattern]="namePattern"
                            placeholder="First Name" [(ngModel)]="newInternalUser.FirstName" required
                            #firstName="ngModel" maxlength="30" />
                        </div>
                        <div [ngClass]="(ValidateFirstName==true)?'container-hide':'container-unhide'">
                          <span class="input-ErrorField">Invalid First Name</span>
                        </div>
                      </td>
                      <td>
                        <div class="addMandatory widthChild150 marginLeftMin15">
                          <input name="lastName" type="text" pInputText [pattern]="namePattern" placeholder="Last Name"
                            [(ngModel)]="newInternalUser.LastName" maxlength="30" required #lastName="ngModel" />
                        </div>
                        <div [ngClass]="(ValidateLastName==true)?'container-hide':'container-unhide'">
                          <span class="input-ErrorField">Invalid Last Name</span>
                        </div>
                      </td>
                      <td>
                        <div class="addMandatory widthChild200 marginLeftMin15">
                          <input name="email" type="email" pInputText maxlength="50" placeholder="Email ID"
                            [(ngModel)]="newInternalUser.EmailID" #email="ngModel" required
                            [pattern]="internalEmailPattern" />
                        </div>
                        <div>
                          <span class="input-ErrorField" *ngIf="!ValidateEmail"
                            [ngClass]="(ValidateEmail==true)?'container-hide':'container-unhide'">Invalid Email</span>
                          <span class="input-ErrorField"
                            [ngClass]="(isInEmailExist==true)?'container-hide':'container-unhide'">Email already
                            exists</span>
                        </div>
                      </td>
                      <td>
                        <div class="addMandatory marginLeftMin15">
                          <p-select *ngIf="userRoles" [options]="userRoles" [autoWidth]="false" panelStyleClass="custom-dropdown"
                            [(ngModel)]="newInternalUser.newRole" placeholder="Select Role" name="userRoles"
                            optionLabel="roleName" dataKey="roleID" required appendTo="body">
                            <ng-template pTemplate="selectedItem" let-selectedOption>
                              {{ selectedOption?.roleName }}
                            </ng-template>
                            <ng-template pTemplate="item" let-option>
                              {{ option.roleName }}
                            </ng-template>
                          </p-select>
                        </div>
                        <div [ngClass]="(ValidateRole==true)?'container-hide':'container-unhide'">
                          <span class="input-ErrorField">Role Required</span>
                        </div>
                      </td>
                      <td>
                        <p-autoComplete class="custom-agency custom-editagency"
                          [inputStyle]="{'width':'175px','margin-left':'-5px'}" [(ngModel)]="newInternalUser.newAgency"
                          [suggestions]="agencyFilter" emptyMessage="No Records Found" forceSelection="true"
                          (completeMethod)="agencyAutocompleteFilter($event)" [size]="30" #agency
                          placeholder="Type Agency" name="agency" optionLabel="agencyName" datakey="agencyID"
                          (onClear)="clearValue()" [minLength]="1">
                          <ng-template pTemplate="item" let-agency>
                            {{ agency.agencyName }}
                          </ng-template>
                          <ng-template pTemplate="selectedItem" let-agency>
                            {{ agency.agencyName }}
                          </ng-template>
                        </p-autoComplete>
                        <div>
 
                        </div>
                        <div>
                          &nbsp;
                        </div>
                      </td>
                      <td>
                        <div style="margin-left: -15px">
                          <button type="submit" class="btn btn-success order_buttonicon" [disabled]="disableSubmitbtn">
                            <i class="fa fa-check"></i> Submit
                          </button>
                          <button type="button" (click)="showAddInternalUserRowClose();myForm.reset()"
                            class="btn btn-success order_btncancel">
                            <i class="fa fa-remove"></i> Cancel</button>
                          <div>
                            &nbsp;
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </form>
            </div>
          </div>
          <div id="adminComponentTable2" >
            <!--Internal User Table starts -->
            <p-table #dtInternal [value]="internalUser" [rows]="9" [paginator]="true" [pageLinks]="10"
              [responsiveLayout]="'scroll'" [editable]="true"
              [globalFilterFields]="['sso', 'firstName', 'lastName', 'email', 'roles.roleName', 'agency.agencyName']"
              [reorderableColumns]="true" columnResizeMode="fit" [resizableColumns]="true"
              [tableStyle]="{'table-layout':'inherit','width':'100%','border-collapse':'collapse','border':'1px solid #c5c5c5'}"
              emptyMessage="No records found">
 
              <!-- Filter Icon Column -->
              <ng-template pTemplate="header">
                <tr>
                  <th style="width:38px">
                    <i class="fa fa-fw fa-filter cursorpointer" (click)="internalUsersFilterToggle($event)"></i>
                  </th>
                  <th pSortableColumn = "sso" style="width:85px">SSO
                    <p-sortIcon field="sso"></p-sortIcon>
                  </th>
                    <th pSortableColumn="firstName" style="width:160px">First Name
                    <p-sortIcon field="firstName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="lastName" style="width:160px">Last Name
                    <p-sortIcon field="lastName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="email" style="width:230px">Email ID
                    <p-sortIcon field="email"></p-sortIcon>
                    </th>
                    <th pSortableColumn="roles.roleName" style="width:120px">Role
                    <p-sortIcon field="roles.roleName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="agency.agencyName" style="width:230px">Agency
                    <p-sortIcon field="agency.agencyName"></p-sortIcon>
                    </th>
                    <th style="width:110px"></th>
                </tr>
              </ng-template>
 
              <!-- Row Body -->
              <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                <tr>
                  <td>
                    <!-- Intentionally blank or used for row-level controls -->
                  </td>
 
                  <!-- SSO -->
                  <td>
                    <ng-container *ngIf="!rowData.isEditable">{{ rowData.sso }}</ng-container>
                    <ng-container *ngIf="rowData.isEditable">
                      <input pInputText type="text" [(ngModel)]="rowData.sso" minlength="9" maxlength="9"
                        pKeyFilter="pint" required [pattern]="ssoPattern" (ngModelChange)="checkSSOField(rowData)" />
                      <div *ngIf="!invalidSSO" class="text-danger small mt-1">Invalid SSO</div>
                      <div *ngIf="!duplicateSSOEditIN" class="text-danger small mt-1">Duplicate SSO</div>
                    </ng-container>
                  </td>
 
                  <!-- First Name -->
                  <td>
                    <ng-container *ngIf="!rowData.isEditable">{{ rowData.firstName }}</ng-container>
                    <ng-container *ngIf="rowData.isEditable">
                      <input pInputText type="text" [(ngModel)]="rowData.firstName" maxlength="30"
                        (ngModelChange)="checkInFirstNameCheck(rowData)" />
                      <div *ngIf="!invalidInEditFirstName" class="input-ErrorField">Invalid First Name</div>
                    </ng-container>
                  </td>
 
                  <!-- Last Name -->
                  <td>
                    <ng-container *ngIf="!rowData.isEditable">{{ rowData.lastName }}</ng-container>
                    <ng-container *ngIf="rowData.isEditable">
                      <input pInputText type="text" [(ngModel)]="rowData.lastName" maxlength="30"
                        (ngModelChange)="checkInLastNameCheck(rowData)" />
                        <div *ngIf="!invalidInEditLastName" class="input-ErrorField">Invalid Last Name</div>
                    </ng-container>
                  </td>
 
                  <!-- Email ID -->
                  <td>
                    <ng-container *ngIf="!rowData.isEditable">{{ rowData.email }}</ng-container>
                    <ng-container *ngIf="rowData.isEditable">
                        <input pInputText type="email" [(ngModel)]="rowData.email" maxlength="50"
                          [pattern]="internalEmailPattern" (ngModelChange)="checkInEmail(rowData)" />
                          <div *ngIf="!invalidInEditEmail" class="input-ErrorField" style="margin-top:2px;">Invalid Email</div>
                          <div *ngIf="!duplicateEmailEditIN" class="input-ErrorField" style="margin-top:2px;">Email already exists</div>
                    </ng-container>
                  </td>
 
                  <!-- Role -->
                  <td>
                    <ng-container *ngIf="!rowData.isEditable">
                      {{ rowData.roles?.roleName }}
                    </ng-container>
                    <ng-container *ngIf="rowData.isEditable">
                      <p-select *ngIf="userRoles" [options]="userRoles" optionLabel="roleName"
                        [(ngModel)]="rowData.roles" placeholder="Choose" [autoWidth]="false" appendTo="body" dataKey="roleID">
                        <ng-template pTemplate="selectedItem" let-selectedOption>
                          {{ selectedOption?.roleName }}
                        </ng-template>
                        <ng-template pTemplate="item" let-option>
                          {{ option.roleName }}
                        </ng-template>
                      </p-select>
                    </ng-container>
                  </td>
 
                  <!-- Agency -->
                  <td>
                    <ng-container *ngIf="rowData.agency">
                      {{ rowData.agency.agencyName }}
                    </ng-container>
                    <!-- Show blank if no agency -->
                    <ng-container *ngIf="!rowData.agency">
                    </ng-container>
                    <ng-container *ngIf="rowData.isEditable">
                      <p-autoComplete [(ngModel)]="rowData.agency" [suggestions]="agencyFilter" optionLabel="agencyName"
                        emptyMessage="No Records Found" (completeMethod)="agencyAutocompleteFilter($event)"
                        appendTo="body" (ngModelChange)="checkInAgency(rowData)">
                        <ng-template pTemplate="item" let-agency>
                          {{ agency.agencyName }}
                        </ng-template>
                        <ng-template pTemplate="selectedItem" let-agency>
                          {{ agency.agencyName }}
                        </ng-template>
                      </p-autoComplete>
                        <div *ngIf="invalidInEditAgency" class="input-ErrorField">Agency Required</div>
                        <div *ngIf="MultiAgencyExist" class="input-ErrorField">Agency already exists for user</div>
                    </ng-container>
                  </td>
 
                  <!-- Actions -->
                  <td>
                    <ng-container *ngIf="!rowData.isEditable">
                      <button pButton icon="fa fa-pencil" class="ui-button-success" pTooltip="Edit" tooltipPosition="top"
                        (click)="onRowEditSelect(rowData,myForm)" [disabled]="disableINeditBtn">
                      </button>
                    </ng-container>

                    <button pButton icon="fa fa-trash" class="ui-button-danger"
                      (click)="onRowINdeleteSelect(rowData)"
                      [disabled]="disableINdeleteBtn"
                      pTooltip="Delete" tooltipPosition="top">
                    </button>

                    <ng-container *ngIf="rowData.isEditable">
                      <button pButton icon="fa fa-check" class="ui-button-success" pTooltip="Save" tooltipPosition="top"
                        (click)="onUpdateInternalRowClick(rowData)" [disabled]="disableINUpdateBtn">
                      </button>
                    </ng-container>
                    <ng-container *ngIf="rowData.isEditable">
                      <button pButton icon="fa fa-close" class="ui-button-danger" pTooltip="Cancel" tooltipPosition="top"
                        (click)="onCancelRowClick(rowData)">
                      </button>
                    </ng-container>
                  </td>
                </tr>
              </ng-template>
            </p-table>
 
          </div>
          <!--Internal User Table Ends here-->
        </div>
        <!-- Internal Tabls ends here -->
        <!-- external Tabls starts here -->
        <div class="tab-pane" [ngClass]="{ 'active': ShowExternalUser}"  id="2a">
          <!-- Buttons -->
          <div class="userbtn_main">
            <button type="button" class="btn userlog_btn" [hidden]="hideinternal" (click)="GetUSerLog()">
              User Log <img src="/assets/images/userlog_icon.png">
            </button>
            <!-- <button [ngClass]="{ 'd-none': hideinternal }" type="button" class="btn userlog_btn" (click)="GetUSerLog()">
              User Log <img src="/assets/images/userlog_icon.png">
            </button> -->
 
            <!-- <button type="button" class="btn transaction_btn" [hidden]="hideinternal" (click)="GetTransaction()">
              Transactions <img src="/assets/images/transaction_icon.png">
            </button> -->
            <button [ngClass]="{ 'd-none': hideinternal }" type="button" class="btn transaction_btn" (click)="GetTransaction()">
              Transactions <img src="/assets/images/transaction_icon.png">
            </button>
            
 
            <button type="button" class="btn external_add_internaluserbtn" (click)="showAddExternalUserArea()">
              Add External User <span class="glyphicon glyphicon-plus"></span>
            </button>
 
            <!-- <button type="button" class="btn bulk_upload" [hidden]="hideinternal" (click)="onBulkUploadClick()">
              Bulk Upload <span class="glyphicon glyphicon-arrow-up"></span>
            </button>
          </div> -->
          <button *ngIf="!hideinternal" type="button" class="btn bulk_upload" (click)="onBulkUploadClick()">
            Bulk Upload <span class="glyphicon glyphicon-arrow-up"></span>
          </button>
        </div>
          
          <!-- ✅ Bulk Upload Dialog -->
          <p-dialog header="Bulk Upload" [(visible)]="displayBulkUploadPopUp" [modal]="true"
            [style]="{ width: '350px' }" [baseZIndex]="10000" [closable]="false" [blockScroll]="true">
 
            <form #bulkUploadFrm>
              
              <span [ngClass]="{'d-none':invalidFileFormat}" class="input-ErrorField">
                Invalid File Format! Please insert a .csv file.
              </span>
              <span [ngClass]="{'d-none': invalidData}" class="input-ErrorField">
                Mandatory fields are missing or invalid!
              </span>
              <span [ngClass]="{'d-none': fileDataError}" class="input-ErrorField">
                File does not contain data.
              </span>
 
              <br />
 
              <input type="file" accept=".csv" (change)="openFile($event)"
                (click)="resetBulkUpload(); bulkUploadFrm.reset();" />
 
              <br />
              <span [ngClass]="{'d-none': saveMsg}" class="input-ErrorField">
                Uploaded Successfully.
              </span>
 
              <br /><br />
 
              <!-- ✅ Dialog Footer -->
              <ng-template pTemplate="footer">
                <button type="button" pButton icon="fa fa-check" label="Upload" class="ui-button-success"
                  [disabled]="disableExUploadBtn" (click)="onExternalUserBulkUpload(); bulkUploadFrm.reset();">
                </button>
                <button type="button" pButton icon="fa fa-close" label="Cancel" class="ui-button-danger" (click)="
            displayBulkUploadPopUp = false;
            bulkUploadFrm.reset();
            invalidFileFormat = true;
            disableExUploadBtn = false;
          ">
                </button>
              </ng-template>
            </form>
          </p-dialog>
 
          <!-- Pop Up for Bulk Upload Ends -->
          <!-- External User Golbal Search Starts-->
          
          <div [ngClass]="{'d-none': !ShowExternalUser}" class="searchmain">
            <input id="ExternalUserTableSearch" #ExternalUserTableSearch type="text" class="searchbox" pInputText
              size="50" placeholder="Search Alphanumeric values here..." [(ngModel)]="externalGlobalFilter"
              (input)="dtExternal.filterGlobal(externalGlobalFilter, 'contains')" />
            <i class="fa fa-search search_modified"></i>
          </div>
          
          <!-- External User Golbal Search Ends-->
  
          <!-- Add New External User starts-->
          <div [ngClass]="{'d-none': !showAddExternalUserRow}">
            <div class="no-more-tables addDataInTable externalAddData">
              <form #myExternalUserForm="ngForm" (ngSubmit)="onAddNewExternalUserSubmit(myExternalUserForm)">
                <table style="border-spacing: 1px;border-collapse: collapse;table-layout: inherit;padding: 1px;">
                  <tr>
                    <td>
                      <div class="addMandatory">
                        <input name="firstName" type="text" pInputText [(ngModel)]="newExtenalUser.FirstName"
                          #firstName="ngModel" placeholder="First Name" maxlength="30" required [pattern]="namePattern">
                      </div>
                      <div [ngClass]="(ValidateExFirstName==true)?'container-hide':'container-unhide'">
                        <span class="input-ErrorField">Invalid First Name</span>
                      </div>
                    </td>
                    <td>
                      <div class="addMandatory">
                        <input name="lastName" type="text" pInputText [pattern]="namePattern" placeholder="Last Name"
                          [(ngModel)]="newExtenalUser.LastName" maxlength="30" required #lastName="ngModel">
                      </div>
                      <div [ngClass]="(ValidateExLastName==true)?'container-hide':'container-unhide'">
                        <span class="input-ErrorField">Invalid Last Name</span>
                      </div>
                    </td>
                    <td>
                      <div class="addMandatory">
                        <input name="email" type="text" pInputText maxlength="50" placeholder="Email ID"
                          [(ngModel)]="newExtenalUser.EmailID" #emailId="ngModel" required [pattern]="emailPattern">
                      </div>
                      <div>
                        <span class="input-ErrorField" *ngIf="!ValidateExEmail"
                          [ngClass]="(ValidateExEmail==true)?'container-hide':'container-unhide'">Invalid Email</span>
                        <span class="input-ErrorField"
                          [ngClass]="(isExEmailExist==true)?'container-hide':'container-unhide'">Email already
                          exists</span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <div class="addMandatory">
                          <p-autoComplete class="custom-agency custom-editagency"
                            [(ngModel)]="newExtenalUser.newExAgency" [suggestions]="agencyFilter"
                            emptyMessage="No Records Found" forceSelection="true"
                            (completeMethod)="agencyAutocompleteFilter($event)" [size]="30" #agency
                            placeholder="Type Agency" name="agency" optionLabel="agencyName" datakey="agencyID"
                            [minLength]="1" (onClear)="clearExValue()"
                            (ngModelChange)="checkAddExAgency($event, newExtenalUser.EmailID)" required>
                            <ng-template pTemplate="item" let-agency>
                              {{ agency.agencyName }}
                            </ng-template>
                            <ng-template pTemplate="selectedItem" let-agency>
                              {{ agency.agencyName }}
                            </ng-template>
                          </p-autoComplete>
 
                        </div>
                        <div>
                          <span class="input-ErrorField" *ngIf="!ValidateExAgency"
                            [ngClass]="(ValidateExAgency==true)?'container-hide':'container-unhide'">Agency
                            Required</span>
                          <span class="input-ErrorField"
                            [ngClass]="(AddMultiAgencyExist==false)?'container-hide':'container-unhide'">Agency already
                            exists for user</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <button type="submit" class="btn btn-success order_buttonicon">
                        <i class="fa fa-check"></i> Submit
                      </button>
                      <button type="button" (click)="showAddExternalUserRowClose();myExternalUserForm.reset()"
                        class="btn btn-success order_btncancel">
                        <i class="fa fa-remove"></i> Cancel</button>
                      <div>
                        &nbsp;
                      </div>
                    </td>
                  </tr>
                </table>
              </form>
            </div>
          </div>
          <!-- Add New External User ends-->
          <!--External User Table starts -->
          
        <div id="adminComponentTable1">
          <p-table #dtExternal [value]="externalUser" [paginator]="true" [rows]="9" [responsiveLayout]="'scroll'"
            [globalFilterFields]="['firstName', 'lastName', 'email','agency.agencyName']" [(selection)]="selectedExternalUsers"
            [rowHover]="true" [resizableColumns]="true" [columnResizeMode]="'fit'" [reorderableColumns]="true"
            [tableStyle]="{'table-layout':'inherit','width':'100%','border-collapse':'collapse','border':'1px solid #c5c5c5'}" (onRowSelect)="onExternalUserRowSelect($event)"
            (onRowUnselect)="onExternalUserRowUnSelect($event)" (onHeaderCheckboxToggle)="HeaderCheckBoxToggle($event)"
            [selectionPageOnly]="false" dataKey="id">
 
            <!-- Filter Icon Header -->
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 38px;">
                  <i class="fa fa-fw fa-filter cursorpointer" (click)="externalUsersFilterToggle($event)"></i>
                </th>
                <th pSortableColumn="firstName" style="width:160px">
                  First Name
                  <p-sortIcon field="firstName"></p-sortIcon>
                </th>
                <th pSortableColumn="lastName" style="width:160px">
                  Last Name
                  <p-sortIcon field="lastName"></p-sortIcon>
                </th>
                <th pSortableColumn="email" style="width:230px">
                  Email ID
                  <p-sortIcon field="email"></p-sortIcon>
                </th>
                <th pSortableColumn="agency.agencyName" style="width:230px">
                  Agency
                  <p-sortIcon field="agency.agencyName"></p-sortIcon>
                </th>
                <th *ngIf="!hideinternal" style="width: 110px;"></th>
              </tr>
            </ng-template>
 
            <!-- Table Body -->
            <ng-template pTemplate="body" let-row let-editing="editing">
            <tr>
              <!-- Placeholder for filter column -->
              <td></td>
 
              <!-- First Name -->
              <td>
                <ng-container *ngIf="!row.isEditable; else editFirstName">
                  {{ row.firstName }}
                </ng-container>
                <ng-template #editFirstName>
                  <input type="text" [(ngModel)]="row.firstName" maxlength="30"
                    (ngModelChange)="checkExFirstNameCheck(row)" />
                 <div><span *ngIf="!invalidExEditFirstName" class="input-ErrorField">Invalid First Name</span></div>
                </ng-template>
              </td>
 
              <!-- Last Name -->
              <td>
                <ng-container *ngIf="!row.isEditable; else editLastName">
                  {{ row.lastName }}
                </ng-container>
                <ng-template #editLastName>
                  <input type="text" [(ngModel)]="row.lastName" maxlength="30"
                    (ngModelChange)="checkExLastNameCheck(row)" />
                    <div>
                  <span *ngIf="!invalidExEditLastName" class="input-ErrorField">Invalid Last Name</span></div>
                </ng-template>
              </td>
 
              <!-- Email -->
              <td>
                <ng-container *ngIf="!row.isEditable; else editEmail">
                  {{ row.email }}
                </ng-container>
              
                <ng-template #editEmail>
                  <input type="text" [(ngModel)]="row.email" maxlength="50" (ngModelChange)="checkExEmail(row)" />
                  <div>
                    <span *ngIf="!invalidExEditEmail" class="input-ErrorField">Invalid Email</span>
                    <span *ngIf="!duplicateEmailEditEx" class="input-ErrorField">Email already exists</span>
                  </div>
                </ng-template>
              </td>
 
              <!-- Agency -->
              <td>
                <ng-container *ngIf="!row.isEditable; else editAgency">
                  {{ row.agency?.agencyName || '' }}
                </ng-container>
                <ng-template #editAgency>
                  <p-autoComplete  appendTo="body" [(ngModel)]="selectedExAgency" [suggestions]="agencyFilter" optionLabel="agencyName"
                    placeholder="Choose Agency" (completeMethod)="agencyAutocompleteFilter($event)"
                    (ngModelChange)="checkExAgency(row, selectedExAgency)">
                    <ng-template pTemplate="item" let-agency>
                      {{ agency.agencyName }}
                    </ng-template>
                    <ng-template pTemplate="selectedItem" let-agency>
                      {{ agency.agencyName }}
                    </ng-template>
                  </p-autoComplete>
                  <div>
                  <span *ngIf="!invalidExEditAgency" class="input-ErrorField">Agency Required</span>
                  <span *ngIf="MultiAgencyExist" class="input-ErrorField">Agency already exists for user</span>
                </div>
                </ng-template>
              </td>
 
              <!-- Actions -->
              <td *ngIf="!hideinternal">
                <ng-container *ngIf="!row.isEditable">
                  <button pButton icon="fa fa-pencil" class="ui-button-success" tooltip="Edit"
                    (click)="onRowExternalEditSelect(row, myExternalUserForm)" [disabled]="disableExEditBtn">
                  </button>
                

                  <button pButton icon="fa fa-trash" class="ui-button-danger" pTooltip="Delete" tooltipPosition="top"
                    (click)="onRowExternalDelete(row)" [disabled]="disableExDeleteBtn">
                  </button>
                </ng-container>
                <ng-container *ngIf="row.isEditable">
                  <button pButton icon="fa fa-check" class="ui-button-success" tooltip="Save"
                    (click)="onUpdateExternalRowClick(row)" [disabled]="disableExUpdateBtn">
                  </button>
                  <button pButton icon="fa fa-close" class="ui-button-danger" tooltip="Cancel"
                    (click)="onCancelExternalRowClick(row)">
                  </button>
                </ng-container>
              </td>
            </tr>
            </ng-template>
          </p-table>
        </div>
          <!--External User Table Ends here-->
        
      </div>
        <!-- external Tabls ends here -->
      </div>
    </div>
  </div>
</div>
